"use client";

import { useDispatch } from "react-redux";
import { closeModal } from "@/src/store/slices/allModalSlice";
import { clearAuthCookies } from "@/src/utils/authCookies";
import { getHomePath } from "@/src/routes/routes";
import { Button } from "@heroui/react";
import { LogoutIconSVG } from "@/src/ui/AllSVG";
import { useRouter } from "nextjs-toploader/app";

export default function LogoutConfirmModal() {
    const dispatch = useDispatch();
    const router = useRouter();

    const handleLogout = () => {
        dispatch(closeModal());
        clearAuthCookies();
        router.push(getHomePath());
    };

    return (
        <div className="flex flex-col items-center gap-6 py-2 text-center">
            <div className="flex items-center justify-center w-14 h-14 rounded-full bg-red-50 text-red-500">
                <LogoutIconSVG />
            </div>

            <div className="space-y-1.5">
                <h3 className="text-base font-semibold">Log out</h3>
                <p className="text-sm text-body-color/60 max-w-xs">
                    Are you sure you want to log out? You will need to sign in again to access your account.
                </p>
            </div>

            <div className="flex gap-3 w-full">
                <Button
                    onPress={() => dispatch(closeModal())}
                    className="flex-1 border border-muted-color bg-transparent text-body-color text-sm font-medium rounded-full py-2.5"
                >
                    Cancel
                </Button>
                <Button onPress={handleLogout} className="flex-1 bg-red-500 text-white text-sm font-medium rounded-full py-2.5">
                    Log out
                </Button>
            </div>
        </div>
    );
}
